export class ErrorMessagesConstants {
  static readonly NOT_EMPTY_FIELD = `This field shouldn't be empty.`;
  static readonly REQUIRED_FIELD = 'This field is required.';
  static readonly MAX_LENGTH = 'Maximum characters length is';
  static readonly NO_SPACE = `Password can't contain spaces`;
  static readonly EMAIL_EXISTS ='The email is already existed';
  static readonly INVALID_PHONE_NUMBER = 'Phone number is invalid';
}
